import { IsOptional, IsString, MaxLength } from 'class-validator';

export class UpdateEquipmentInactivityLabelDto {
  @IsString()
  @IsOptional()
  @MaxLength(120)
  label?: string;
}
